import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const reasons = [
  {
    emoji: "🎉",
    title: "Идеально для вечеринки",
    description: "Хит про каждого гостя — танцпол взрывается!",
  },
  {
    emoji: "🎁",
    title: "Оригинальный подарок",
    description: "Песня, которую невозможно купить в магазине.",
  },
  {
    emoji: "😂",
    title: "Розыгрыш друга",
    description: "Трек-шутка, от которой он будет в восторге.",
  },
  {
    emoji: "🥂",
    title: "Хит для компании",
    description: "Идеальный способ поднять настроение всем вокруг.",
  },
];

const WhyWowSection = () => {
  return (
    <section className="py-12 relative" id="why-wow">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-foreground">
            Почему это <span className="text-gradient-primary">вау</span>?
          </h2>
          <p className="text-muted-foreground text-base max-w-md mx-auto">
            Персональная песня — подарок, который невозможно забыть
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-soft transition-all duration-300 text-center"
            >
              <span className="text-4xl mb-3 block">{reason.emoji}</span>
              <h3 className="font-display text-base font-semibold mb-2 text-foreground">{reason.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Button className="shadow-soft" asChild>
            <Link to="/create">
              🔥 Создать хит бесплатно
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyWowSection;
